module.exports = __webpack_public_path__ + "img/icon_upload_modal.90aeefff.svg";